'use client';

import { c as _c } from "react/compiler-runtime";
import { useParams } from 'next/navigation';
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import { Button } from 'react-aria-components';
import ListingFilterNew from '@/features/listing/components/listings-filters/listing-filter-new/listing-filter-new';
import { LISTING_URL_PART_VARIANTS } from '@/features/listing/constants/listing-constants';
import { LISTINGS_TYPE_FILTER } from '@/features/listing/constants/listings-filters-constants';
import { setCookieServiceType } from '@/features/listing/cookies/cookie-service-type';
import { type ListingsFilterName } from '@/features/listing/types/listing-filters-types';
import { type ListingType, type ListingUrl } from '@/features/listing/types/listing-types';
import { useRouter } from '@/i18n/routing';
import styles from './listing-type-filter.module.scss';
interface ListingTypeFilterProps {
  onFilterDisplayChange: (filterName: ListingsFilterName | null) => void;
  filterLink: {
    pathname: string;
    searchParams: URLSearchParams;
  };
}
export default function ListingTypeFilter(props) {
  const $ = _c(19);
  const {
    filterLink,
    onFilterDisplayChange
  } = props;
  const translationsFilterType = useTranslations("listing.filters.type");
  const params = useParams();
  const router = useRouter();
  const currentListingType = LISTING_URL_PART_VARIANTS[params.listingType as ListingUrl];
  const [isPopoverOpen, setPopoverOpen] = useState(false);
  let t0;
  if ($[0] !== filterLink || $[1] !== params.listingType || $[2] !== router) {
    t0 = value => () => {
      const selectedListingType = LISTINGS_TYPE_FILTER.options.find(filter => filter.value === value);
      if (selectedListingType) {
        setCookieServiceType({
          data: selectedListingType.value
        });
        setPopoverOpen(false);
        const updatedPathname = filterLink.pathname.replace(params.listingType as string, selectedListingType.pathValue);
        router.push(updatedPathname);
      }
    };
    $[0] = filterLink;
    $[1] = params.listingType;
    $[2] = router;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const handleChange = t0;
  const t1 = `options.${currentListingType}.button`;
  let t2;
  if ($[4] !== t1 || $[5] !== translationsFilterType) {
    t2 = translationsFilterType(t1);
    $[4] = t1;
    $[5] = translationsFilterType;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== translationsFilterType) {
    t3 = translationsFilterType("dropdown-title");
    $[7] = translationsFilterType;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== currentListingType || $[10] !== handleChange || $[11] !== translationsFilterType) {
    t4 = LISTINGS_TYPE_FILTER.options.map(option => {
      const Icon = option.icon;
      return <Button key={option.value} className={styles.filterToggle} onPress={handleChange(option.value)} isDisabled={option.value === currentListingType}>{Icon && <Icon size={18} />}<span>{translationsFilterType(`options.${option.value}.label`)}</span></Button>;
    });
    $[9] = currentListingType;
    $[10] = handleChange;
    $[11] = translationsFilterType;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== isPopoverOpen || $[14] !== onFilterDisplayChange || $[15] !== t2 || $[16] !== t3 || $[17] !== t4) {
    t5 = <ListingFilterNew buttonText={t2} dialogTitle={t3} onFilterDisplayChange={onFilterDisplayChange} listingFilterName="listingsType" isPopoverOpen={isPopoverOpen} setPopoverOpen={setPopoverOpen} hideButtons={true}>{t4}</ListingFilterNew>;
    $[13] = isPopoverOpen;
    $[14] = onFilterDisplayChange;
    $[15] = t2;
    $[16] = t3;
    $[17] = t4;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  return t5;
}